import { Access } from "../components/ui/Access";
import { BottomCTA } from "../components/ui/BottomCTA";
import { PostBody } from "./components/PostBody";
import { bottomCTA } from "../../datasets/blog/bottomCTA";

export const BlogPost = ({ className, post }) => {
  return (
    <>
      <section className={className}>
        <PostBody content={post} />
      </section>
      <Access />
      <BottomCTA data={bottomCTA} />
    </>
  );
};
